import { NullValue } from './struct.enums';
export function nullValueFromJSON(object) {
    switch (object) {
        case 0:
        case 'NULL_VALUE':
            return NullValue.NULL_VALUE;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return NullValue.UNRECOGNIZED;
    }
}
export function nullValueToJSON(object) {
    switch (object) {
        case NullValue.NULL_VALUE:
            return 'NULL_VALUE';
        default:
            return 'UNKNOWN';
    }
}
const baseStruct = {};
export const Struct = {
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseStruct);
        message.fields = Object.entries((_a = object.fields) !== null && _a !== void 0 ? _a : {}).reduce((acc, [key, value]) => {
            acc[key] = Value.fromJSON(value);
            return acc;
        }, {});
        return message;
    },
    toJSON(message) {
        const obj = {};
        obj.fields = {};
        if (message.fields) {
            Object.entries(message.fields).forEach(([k, v]) => {
                obj.fields[k] = Value.toJSON(v);
            });
        }
        return obj;
    },
};
const baseStruct_FieldsEntry = { key: '' };
export const Struct_FieldsEntry = {
    fromJSON(object) {
        const message = Object.assign({}, baseStruct_FieldsEntry);
        message.key = object.key !== undefined && object.key !== null ? String(object.key) : '';
        message.value =
            object.value !== undefined && object.value !== null
                ? Value.fromJSON(object.value)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.key !== undefined && (obj.key = message.key);
        message.value !== undefined &&
            (obj.value = message.value ? Value.toJSON(message.value) : undefined);
        return obj;
    },
};
const baseValue = {};
export const Value = {
    fromJSON(object) {
        const message = Object.assign({}, baseValue);
        message.nullValue =
            object.nullValue !== undefined && object.nullValue !== null
                ? nullValueFromJSON(object.nullValue)
                : undefined;
        message.numberValue =
            object.numberValue !== undefined && object.numberValue !== null
                ? Number(object.numberValue)
                : undefined;
        message.stringValue =
            object.stringValue !== undefined && object.stringValue !== null
                ? String(object.stringValue)
                : undefined;
        message.boolValue =
            object.boolValue !== undefined && object.boolValue !== null
                ? Boolean(object.boolValue)
                : undefined;
        message.structValue =
            object.structValue !== undefined && object.structValue !== null
                ? Struct.fromJSON(object.structValue)
                : undefined;
        message.listValue =
            object.listValue !== undefined && object.listValue !== null
                ? ListValue.fromJSON(object.listValue)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.nullValue !== undefined &&
            (obj.nullValue =
                message.nullValue !== undefined ? nullValueToJSON(message.nullValue) : undefined);
        message.numberValue !== undefined && (obj.numberValue = message.numberValue);
        message.stringValue !== undefined && (obj.stringValue = message.stringValue);
        message.boolValue !== undefined && (obj.boolValue = message.boolValue);
        message.structValue !== undefined &&
            (obj.structValue = message.structValue ? Struct.toJSON(message.structValue) : undefined);
        message.listValue !== undefined &&
            (obj.listValue = message.listValue ? ListValue.toJSON(message.listValue) : undefined);
        return obj;
    },
};
const baseListValue = {};
export const ListValue = {
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseListValue);
        message.values = ((_a = object.values) !== null && _a !== void 0 ? _a : []).map((e) => Value.fromJSON(e));
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.values) {
            obj.values = message.values.map(e => (e ? Value.toJSON(e) : undefined));
        }
        else {
            obj.values = [];
        }
        return obj;
    },
};
//# sourceMappingURL=struct.js.map